/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { RouteComponentProps, navigate, useLocation } from '@reach/router';
import React from 'react';
import Backdrop from '../../../backdrop/Backdrop';
import PGEButton from '../../../buttons';
import microcopyGroupIds from '../../../pge-plus-common/microcopyGroupIds';
import useContentMgmt from '../../../../hooks/useContentMgmt';
import routes from '../../../../routes';
import colors from '../../../../themes/main-colors';
import theme from '../../../../themes/theme';
import useAuth from '../../../../hooks/useAuth';

type IneligibleState = {
  requestCategory: string;
};
const useStyles = makeStyles(() =>
  createStyles({
    submitBack: {
      borderRadius: '30px',
      minWidth: '130px',

      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    submit: {
      backgroundColor: colors.orange,
      borderColor: colors.orange,
      borderRadius: '30px',
      minWidth: '130px',
      '&:hover': {
        backgroundColor: colors.orange,
        borderColor: colors.orange,
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    container: {
      marginTop: 24,
      marginBottom: 32,
      justifyContent: 'center',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column-reverse',
      },
    },
    gridItem: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 32,
    },
  }),
);
const ConsultationRequestIneligible: React.FC<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  const { isAuthenticated } = useAuth();
  const classes = useStyles();
  const { content, richText, isContentLoading } = useContentMgmt(
    microcopyGroupIds.PGE_PLUS_CONSULTATION,
  );

  const location = useLocation();
  const { requestCategory } = (location.state as IneligibleState) || {};

  if (isContentLoading) {
    return <Backdrop forceOpen />;
  }

  return (
    <Grid container alignItems="center" justify="center" direction="column">
      <Box
        css={{
          marginTop: theme.spacing(4),
        }}
      >
        <Typography
          css={{
            textAlign: 'center',
            lineHeight: `${theme.spacing(4.5)}px !important`,
          }}
          variant={'h1'}
        >
          {content.get('OOPS_SOMETHING_WENT_WRONG')}
        </Typography>
      </Box>
      <Box
        css={css`
          margin-top: 20px;
          & a {
            text-decoration: none;
          }
        `}
      >
        <Typography
          component="div"
          css={{
            fontSize: 20,
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5),
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(3.5),
            [theme.breakpoints.down('xs')]: {
              fontSize: 16,
            },
          }}
        >
          {richText(content.get('CONSULT_REQUEST_ALREADY_MADE'), {
            PRODUCT: requestCategory,
          })}
        </Typography>
      </Box>
      <Grid container className={classes.container}>
        <Grid
          item
          className={classes.gridItem}
          css={{
            marginRight: 16,
          }}
        >
          <PGEButton
            fullWidth
            type={'button'}
            variant="outlined"
            color="secondary"
            className={classes.submitBack}
            onClick={() =>
              isAuthenticated
                ? void navigate(routes.PGE_PLUS_SECURE_CONSULTATION_DETAILS)
                : window.history.go(-1)
            }
          >
            {content.get('BACK')}
          </PGEButton>
        </Grid>
        <Grid item className={classes.gridItem}>
          <PGEButton
            fullWidth
            type={'button'}
            variant={'contained'}
            className={classes.submit}
            onClick={() =>
              void navigate(
                isAuthenticated
                  ? routes.PGE_PLUS_EV_CHARGERS_WELCOME_BACK
                  : routes.PGE_PLUS_PUBLIC_LANDING_PAGE,
              )
            }
          >
            {content.get('OK')}
          </PGEButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ConsultationRequestIneligible;
